import { render, staticRenderFns } from "./ProductCarousel.vue?vue&type=template&id=d4211a94&scoped=true&lang=pug"
import script from "./ProductCarousel.vue?vue&type=script&lang=js"
export * from "./ProductCarousel.vue?vue&type=script&lang=js"
import style0 from "./ProductCarousel.vue?vue&type=style&index=0&id=d4211a94&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4211a94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4211a94')) {
      api.createRecord('d4211a94', component.options)
    } else {
      api.reload('d4211a94', component.options)
    }
    module.hot.accept("./ProductCarousel.vue?vue&type=template&id=d4211a94&scoped=true&lang=pug", function () {
      api.rerender('d4211a94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/ProductCarousel.vue"
export default component.exports